/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tokenExchangeExchange } from "../funcs/tokenExchangeExchange.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { TokenResult } from "../models/components/tokenresult.js";
import {
  TokenExchangeRequest,
  TokenExchangeSecurity,
} from "../models/operations/tokenexchange.js";
import { unwrapAsync } from "../types/fp.js";

export class TokenExchange extends ClientSDK {
  /**
   * exchange tokenExchange
   *
   * @remarks
   * Exchange the org-scoped device-agent install credential plus a vouched user email for a long-lived, per-user API key carrying the 'agent_user' scope. Authenticated with an org-scoped API key carrying the 'agent' scope — deliberately broader than the 'agent_user' scope the minted per-user keys carry, so a leaked per-user key cannot re-enter this endpoint to forge another user's key. The raw key is returned exactly once.
   */
  async exchange(
    request: TokenExchangeRequest,
    security?: TokenExchangeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TokenResult> {
    return unwrapAsync(tokenExchangeExchange(
      this,
      request,
      security,
      options,
    ));
  }
}
